import React from 'react';

const AuthWrapper = ({ children, className }) => {
  return (
    <div className="flex flex-col min-h-[82vh] justify-center items-center pt-20 lg:pt-0">
      <div className={`${className ? className : ''} w-full px-5 pb-5`}>{children}</div>
    </div>
  );
};

export default AuthWrapper;
